import axios from 'axios';

// Create an axios instance
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5001', // Default to localhost if not set
});

/** Build full URL for avatar. API may return "avatars/uuid.jpg" or "/v1/uploads/avatars/uuid.jpg". */
export function getAvatarUrl(avatarPath: string | null | undefined): string | null {
  if (!avatarPath) return null;
  const base = (api.defaults.baseURL || '').replace(/\/$/, '').replace(/\/v1\/?$/, '');
  if (!base) return avatarPath.startsWith('http') ? avatarPath : null;
  const path = avatarPath.startsWith('/') ? avatarPath : `/v1/uploads/${avatarPath}`;
  return `${base}${path}`;
}

// Request interceptor to add token to requests
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle token expiration / invalid token
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    const status = error.response?.status;
    const message = error.response?.data?.message;

    // Invalidate session on 401 or when backend explicitly says token is invalid
    const isInvalidToken =
      status === 401 ||
      (typeof message === 'string' && message.toLowerCase().includes('invalid token'));

    if (isInvalidToken) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }

    return Promise.reject(error);
  }
);

export default api;